import { Box, Button, styled } from "@outschool/backpack";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useCopyLinkToClipboard } from "@outschool/ui-components-website";
import { Screen } from "@outschool/ui-utils";
import React from "react";

const BUTTON_OVERLAP = 50;

const StyledInput = styled("input")(({ theme }) => ({
  borderRadius: theme.spacing(24),
  paddingBlock: theme.spacing(12),
  paddingInline: theme.spacing(20),
  paddingRight: `${BUTTON_OVERLAP}px`,
  width: "100%",
}));

type Props = React.ComponentPropsWithoutRef<typeof Button> & {
  url: string;
  confirmationText: string;
};

export function CopyLinkToClipboard({
  url,
  children,
  onClick,
  confirmationText,
  ...props
}: Props) {
  const isMobile = Screen.useIsMobile();
  const { wasCopied, onCopy } = useCopyLinkToClipboard();

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    onCopy(url);

    if (onClick) {
      onClick(event);
    }
  };

  return isMobile ? (
    <TrackedButton
      onClick={handleClick}
      variant="outlined"
      disabled={wasCopied}
      {...props}
    >
      {wasCopied ? confirmationText : children}
    </TrackedButton>
  ) : (
    <Box sx={{ display: "flex" }}>
      <StyledInput value={url} disabled />
      <TrackedButton
        onClick={handleClick}
        variant="contained"
        sx={{ ml: `-${BUTTON_OVERLAP}px` }}
        disabled={wasCopied}
        {...props}
      >
        {wasCopied ? confirmationText : children}
      </TrackedButton>
    </Box>
  );
}
